import { p as palette, c as color } from '../base/color-ec580bc4.js';
import { t as typography, l as link } from '../base/typography-dd13a6be.js';
import { a as spacingValues, s as spacing } from '../base/spacing-b4d393ed.js';
import { f as focus } from '../base/focus-97063155.js';
import { g as globals } from '../base/globals-7fe5bdef.js';
import { a as alertStyles } from '../component/alert-24b55293.js';
import { b as breadcrumbs } from '../component/breadcrumb-fc2508bc.js';
import { b as button } from '../component/button-2dbc0f97.js';
import { c as card } from '../component/card-50699470.js';
import { c as checkboxStyles } from '../component/checkbox-23cad0c2.js';
import { c as circularProgressIndicatorStyles } from '../component/circularProgressIndicator-45e295f2.js';
import { d as datepicker } from '../component/datepicker-a5c254bc.js';
import { d as dividerStyles } from '../component/divider-989b8bca.js';
import { d as dropdownStyles } from '../component/dropdown-3dd17c54.js';
import { h as helptipStyles } from '../component/helptip-9911c1d4.js';
import { i as icon } from '../component/icon-14b0913e.js';
import { i as inputStyles } from '../component/input-0c4e4f39.js';
import { l as labelStyles } from '../component/label-105be3d1.js';
import { m as modal } from '../component/modal-afd41bac.js';
import { p as paginationStyles } from '../component/pagination-4f979da8.js';
import { p as pillLegacyStyles } from '../component/pillLegacy-189bffbc.js';
import { p as pillStyles } from '../component/pill-9464e037.js';
import { p as popoverStyles } from '../component/popover-2244ec0a.js';
import { p as portalStyles } from '../component/portal-b4e38c7b.js';
import { p as progressIndicatorStyles } from '../component/progressIndicator-72e93a77.js';
import { r as radioStyles } from '../component/radio-c6d5b40c.js';
import { r as rangeSlider } from '../component/rangeSlider-99683d88.js';
import { s as sectionExpanderStyles } from '../component/sectionExpander-60726729.js';
import { s as sideNavStyles, a as sideNavItemStyles } from '../component/sideNavigation-fe217556.js';
import { s as searchInputStyles } from '../component/searchInput-c93f3adc.js';
import { s as snackbar } from '../component/snackbar-f85ba759.js';
import { s as sortableListStyles } from '../component/sortableList-60f8a8d1.js';
import { s as starRatingStyles } from '../component/starRating-66f09d4c.js';
import { s as stepsStyles } from '../component/steps-2251c31e.js';
import { s as surfaceStyles } from '../component/surface-a180c85c.js';
import { s as switchStyles } from '../component/switch-286f2231.js';
import { t as tableStyles } from '../component/table-47ed451c.js';
import { t as tabNavigationStyles } from '../component/tabNavigation-54c6187a.js';
import { t as tagStyles } from '../component/tag-f9be9644.js';
import { t as textAreaStyles } from '../component/textarea-afd01524.js';
import { t as tooltip } from '../component/tooltip-099cdabb.js';
import { t as touchLink } from '../component/touchLink-b41f7d12.js';
import { t as tree } from '../component/tree-bd8dcfc6.js';
import { t as treeViewStyles } from '../component/treeView-9ec76403.js';
import { a as anchoredAlertStyles } from '../component/anchoredAlert-6198109b.js';
import { s as secondaryView } from '../component/secondaryView-65f735d4.js';
import { s as splitButton } from '../component/splitButton-9ae5e8e0.js';
import { p as peekabooStickyTab } from '../component/peekabooStickyTab-1746f7db.js';
import { p as pageLayout } from '../component/pageLayout-35eddb83.js';
import { s as surfaceDarkStyles } from '../component/surfaceDark-beb6179f.js';
import { s as surfaceDarkInfoStyles } from '../component/surfaceDarkInfo-c7ac00b4.js';
import { s as surfaceLightStyles } from '../component/surfaceLight-50f0efa5.js';

const theme = {
  pageLayout,
  palette,
  spacingValues,
  spacing,
  globals,
  color,
  typography,
  breadcrumbs,
  button: button,
  card,
  divider: dividerStyles,
  dropdown: dropdownStyles,
  form: {
    label: labelStyles,
    input: inputStyles,
    textarea: textAreaStyles,
    search: searchInputStyles,
    checkbox: checkboxStyles,
    radio: radioStyles
  },
  icon,
  message: alertStyles,
  modal,
  navigation: {
    tabs: tabNavigationStyles
  },
  pagination: paginationStyles,
  pillLegacy: pillLegacyStyles,
  pillv2Beta: pillStyles,
  // adding in for TropicalUI support, which references this theme value
  pill: pillStyles,
  popover: popoverStyles,
  portal: portalStyles,
  switch: switchStyles,
  tooltip,
  helptip: helptipStyles,
  datepicker,
  starRating: starRatingStyles,
  sortableList: sortableListStyles,
  sideNav: sideNavStyles,
  sideNavItem: sideNavItemStyles,
  surface: surfaceStyles,
  surfaceLight: surfaceLightStyles,
  surfaceDark: surfaceDarkStyles,
  surfaceDarkInfo: surfaceDarkInfoStyles,
  rangeSlider,
  table: tableStyles,
  tree,
  treeView: treeViewStyles,
  sectionExpander: sectionExpanderStyles,
  tag: tagStyles,
  touchLink,
  steps: stepsStyles,
  focusVisible: focus,
  progressIndicator: progressIndicatorStyles,
  circularProgressIndicator: circularProgressIndicatorStyles,
  snackbar,
  anchoredAlert: anchoredAlertStyles,
  link,
  secondaryView,
  splitButton,
  peekabooStickyTab
};
var defaultTheme = theme;

export { defaultTheme as d };
//# sourceMappingURL=default-b93141be.js.map
